import { render, staticRenderFns } from "./Dowload.vue?vue&type=template&id=021d9176&scoped=true&"
import script from "./Dowload.vue?vue&type=script&lang=js&"
export * from "./Dowload.vue?vue&type=script&lang=js&"
import style0 from "./Dowload.vue?vue&type=style&index=0&id=021d9176&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021d9176",
  null
  
)

export default component.exports